/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Divider, CircularProgress, Card } from "@material-ui/core";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import R403InventoryItemStockViewFilter from "./chunks/R403InventoryItemStockViewFilter";
import DxGridTable from "../../../components/DxGridTable/DxGridTable";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 110,
  },
});

class R403InventoryItemStockView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      showTableFilter: false,

      searchText: "",
      searchTextError: "",

      categoriesData: [],
      categoriesDataLoading: false,
      categoryId: "",
      categoryIdError: "",

      requisitionsList: [],

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.getData(
      "GET",
      "/inventory/C403CommonInventoryItemsCategoriesView",
      null,
      "categoriesData",
      "categoriesDataLoading"
    );
    this.getData(
      "POST",
      "/inventory/C403CommonInventoryItemsRequistionView?categoryId=0",
      null,
      "requisitionsList",
      "isLoading"
    );
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";

    switch (name) {
      case "categoryId":
        if (value) {
          const myCategoryId = value < 0 ? 0 : value;
          this.getData(
            "POST",
            `/inventory/C403CommonInventoryItemsRequistionView?categoryId=${myCategoryId}`,
            null,
            "requisitionsList",
            ""
          );
        }
        break;
      default:
        break;
    }

    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  getData = async (
    method = "",
    endpoint = "",
    data = null,
    stateName = "",
    loadingStateName = ""
  ) => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      method,
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      data,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }
    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  onNewItemButtonClick = () => {
    window.location = "#/F402InventoryItemStockForm";
  };

  render() {
    const { classes } = this.props;
    const tableColumnExtensions = [
      // { columnName: "id", width: 100 },
    ];
    const columns = [
      { name: "categoryLabel", title: "Category" },
      { name: "itemLabel", title: "Material Name" },
      { name: "quantityLabel", title: "Quantity" },
      { name: "remarks", title: "Remarks" },
      { name: "createdOnLabel", title: "Opened On" },
      { name: "createdByLabel", title: "Opened By" },
    ];
    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
        <NavBar isAuthorize />
        <div className={classes.root}>
          <div className={classes.topMargin}>
            <R403InventoryItemStockViewFilter
              state={this.state}
              l
              handleChange={(e) => this.handleChange(e)}
              handleToggleTableFilter={() => this.handleToggleTableFilter()}
              onNewItemButtonClick={() => this.onNewItemButtonClick()}
            />
          </div>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <Card className={classes.topMargin}>
            {!this.state.isLoading ? (
              <DxGridTable
                data={this.state.requisitionsList}
                columns={columns}
                showFilter={this.state.showTableFilter}
                isLoading={this.state.isLoading}
                tableColumnExtensions={tableColumnExtensions}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 50,
                  width: "100%",
                  overflow: "hidden",
                  height: "90px",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </Card>
        </div>
      </Fragment>
    );
  }
}

R403InventoryItemStockView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(R403InventoryItemStockView);
